function updateImageWithHighlights(fullPageContainer) {
    const imageHighlightsSections = document.querySelectorAll('[data-image-highlights-section="true"]');
    
    if (imageHighlightsSections.length === 0) {
        return;
    }

    try {
        // Find all image-with-highlights sections in the new product page
        const newSections = fullPageContainer.querySelectorAll('[data-image-highlights-section="true"]');
        
        if (newSections.length === 0) {
            return;
        }

        // Update each section
        imageHighlightsSections.forEach((currentSection, index) => {
            const newSection = newSections[index];
            
            if (newSection) {
                // Find the shopify-section wrapper for both current and new sections
                const currentSectionWrapper = currentSection.closest('[id^="shopify-section-"]');
                const newSectionWrapper = newSection.closest('[id^="shopify-section-"]');
                
                if (currentSectionWrapper && newSectionWrapper) {
                    // Preserve the wrapper position
                    const parent = currentSectionWrapper.parentNode;
                    const nextSibling = currentSectionWrapper.nextSibling;
                    
                    // Replace the entire section wrapper (includes all Shopify context)
                    currentSectionWrapper.remove();
                    
                    if (nextSibling) {
                        parent.insertBefore(newSectionWrapper, nextSibling);
                    } else {
                        parent.appendChild(newSectionWrapper);
                    }
                    
                    // Reinitialize slideshows in the new section if needed
                    const slideshowElements = newSectionWrapper.querySelectorAll('.splide');
                    if (slideshowElements.length > 0 && window.discoverNewSlideshows) {
                        window.discoverNewSlideshows(newSectionWrapper);
                    }
                } else {
                    // Fallback: replace just the section
                    const parent = currentSection.parentNode;
                    const nextSibling = currentSection.nextSibling;
                    
                    currentSection.remove();
                    
                    if (nextSibling) {
                        parent.insertBefore(newSection, nextSibling);
                    } else {
                        parent.appendChild(newSection);
                    }
                    
                    // Reinitialize slideshows in the new section if needed
                    const slideshowElements = newSection.querySelectorAll('.splide');
                    if (slideshowElements.length > 0 && window.discoverNewSlideshows) {
                        window.discoverNewSlideshows(newSection);
                    }
                }
            }
        });
    } catch (error) {
        console.error('Failed to update image-with-highlights sections:', error);
    }
}

function updateIconColors(productContainer) {
    const productColorElement = productContainer.querySelector('[data-product-color]');
    const pdpColor = productColorElement ? productColorElement.textContent.trim() : '';

    const styleElements = document.querySelectorAll('style[data-block-id]');

    styleElements.forEach(styleElement => {
        const blockId = styleElement.getAttribute('data-block-id');
        if (!blockId) return;

        let currentStyles = styleElement.textContent;

        if (pdpColor) {
            currentStyles = currentStyles.replace(
                /(background-color:\s*)[^;]+;/g,
                `$1${pdpColor};`
            ).replace(
                /(border-color:\s*)[^;]+;/g,
                `$1${pdpColor};`
            );
        } else {
            currentStyles = currentStyles.replace(
                /(background-color:\s*)[^;]+;/g,
                '$1rgba(var(--color-scheme-text),var(--tw-text-opacity));'
            ).replace(
                /(border-color:\s*)[^;]+;/g,
                '$1rgba(var(--color-scheme-text),var(--tw-text-opacity));'
            );
        }

        styleElement.textContent = currentStyles;
    });

    const textElements = document.querySelectorAll('[data-scrolling-text]');
    textElements.forEach(element => {
        if (pdpColor) {
            element.style.color = pdpColor;
        } else {
            element.style.removeProperty('color');
        }
    });

    // Update scrolling-text-with-icons section backgrounds
    const sttiSections = document.querySelectorAll('[data-stti-section="true"]');
    sttiSections.forEach(section => {
        if (pdpColor && pdpColor !== '' && pdpColor.includes('rgb')) {
            // Remove bg-scheme-background class and add bg-scheme-pdp-background class
            section.classList.remove('bg-scheme-background');
            section.classList.add('bg-scheme-pdp-background');

            // Update CSS variable for PDP background color
            const sectionId = section.closest('[id^="shopify-section-"]')?.id;
            if (sectionId) {
                let sectionStyleElement = document.querySelector(`style[data-stti-section="${sectionId}"]`);
                if (!sectionStyleElement) {
                    sectionStyleElement = document.createElement('style');
                    sectionStyleElement.setAttribute('data-stti-section', sectionId);
                    document.head.appendChild(sectionStyleElement);
                }

                sectionStyleElement.textContent = `
                    #${sectionId} {
                        --color-scheme-pdp-background: ${pdpColor.replace('rgb(', '').replace(')', '')};
                    }
                `;
            }
        } else {
            // Keep bg-scheme-pdp-background class but set default background
            section.classList.remove('bg-scheme-background');
            section.classList.add('bg-scheme-pdp-background');

            // Set default background color
            const sectionId = section.closest('[id^="shopify-section-"]')?.id;
            if (sectionId) {
                let sectionStyleElement = document.querySelector(`style[data-stti-section="${sectionId}"]`);
                if (!sectionStyleElement) {
                    sectionStyleElement = document.createElement('style');
                    sectionStyleElement.setAttribute('data-stti-section', sectionId);
                    document.head.appendChild(sectionStyleElement);
                }

                // Get the default background color from CSS variables
                const computedStyle = getComputedStyle(document.documentElement);
                const defaultBgColor = computedStyle.getPropertyValue('--color-scheme-background').trim();

                sectionStyleElement.textContent = `
                    #${sectionId} {
                        --color-scheme-pdp-background: ${defaultBgColor};
                    }
                `;
            }
        }
    });

    // Update sticky cart with new product color
    updateStickyCartColor(pdpColor);
}

function updateStickyCartColor(pdpColor) {
    const stickyCart = document.getElementById('sticky-add-to-cart');
    if (!stickyCart) return;

    let stickyStyleElement = document.querySelector('style[data-sticky-section="sticky-cart"]');
    if (!stickyStyleElement) {
        stickyStyleElement = document.createElement('style');
        stickyStyleElement.setAttribute('data-sticky-section', 'sticky-cart');
        document.head.appendChild(stickyStyleElement);
    }

    if (pdpColor && pdpColor.includes('rgb')) {
        // Extract RGB values (e.g., "rgb(255, 0, 0)" -> "255, 0, 0")
        const rgbValues = pdpColor.replace('rgb(', '').replace(')', '').trim();
        stickyCart.setAttribute('data-product-color', rgbValues);

        // Update CSS custom property for sticky cart container and image wrapper
        stickyStyleElement.textContent = `
            .sticky-cart {
                --color-scheme-pdp-background: ${rgbValues};
            }
        `;
    } else {
        // Reset to default when no color is specified
        stickyCart.removeAttribute('data-product-color');
        stickyStyleElement.textContent = '';
    }
}

/**
 * Process title same way as Liquid template
 * Liquid: {{ product.title | split: '-' | first | split: 'XOXO' | last }}
 */
function processTitleForSticky(title) {
    if (!title) return '';
    
    // Split by '-' and get first part
    const firstSplit = title.split('-')[0];
    
    // Split by 'XOXO' and get last part
    const parts = firstSplit.split('XOXO');
    const lastPart = parts[parts.length - 1];
    
    return lastPart.trim();
}

function updateStickyCart(productContainer, productHandle) {
    const stickyCart = document.getElementById('sticky-add-to-cart');
    if (!stickyCart) return;

    console.log('Updating sticky cart with new product data for handle:', productHandle);

    // Get product information from the updated container
    const titleElement = productContainer.querySelector('h1, .product-title, [class*="title"]');
    const priceElement = productContainer.querySelector('.price, [data-product-price], .product-price, [class*="price"]');
    const colorElement = productContainer.querySelector('[data-product-color]');
    
    console.log('Found elements:', {
        title: titleElement?.textContent?.trim(),
        price: priceElement?.textContent?.trim(),
        color: colorElement?.textContent?.trim()
    });

    // Find stitching product image from the stitching items (metafield image)
    let stitchingImage = null;
    if (productHandle) {
        const stitchingItem = document.querySelector(`sc-stitching-item[data-product-handle="${productHandle}"]`);
        console.log('Found stitching item:', stitchingItem);
        if (stitchingItem) {
            stitchingImage = stitchingItem.querySelector('.stitching-product__image');
            console.log('Found stitching image:', stitchingImage?.src);
        }
    }

    // Update image - use the stitching product image from metafield
    const stickyImageWrapper = stickyCart.querySelector('[data-sticky-image]');
    const stickyImage = stickyImageWrapper?.querySelector('img');
    console.log('Sticky cart image element:', stickyImage);
    
    if (stickyImage) {
        if (stitchingImage) {
            stickyImage.src = stitchingImage.src;
            stickyImage.srcset = stitchingImage.srcset || '';
            stickyImage.alt = titleElement ? titleElement.textContent.trim() : '';
            console.log('✓ Updated sticky image from stitching item:', stitchingImage.src);
        } else {
            // Fallback: use first product image if stitching image not found
            const fallbackImage = productContainer.querySelector('.splide__slide img, .product-media img');
            if (fallbackImage) {
                stickyImage.src = fallbackImage.src;
                stickyImage.srcset = fallbackImage.srcset || '';
                stickyImage.alt = titleElement ? titleElement.textContent.trim() : '';
                console.log('⚠ Updated sticky image from fallback:', fallbackImage.src);
            }
        }
    } else {
        console.error('✗ Sticky cart image element not found!');
    }

    // Update title
    if (titleElement) {
        const stickyTitle = stickyCart.querySelector('[data-sticky-title]');
        if (stickyTitle) {
            const rawTitle = titleElement.textContent.trim();
            const processedTitle = processTitleForSticky(rawTitle);
            stickyTitle.textContent = processedTitle;
            console.log('✓ Updated sticky title:', processedTitle, '(raw:', rawTitle + ')');
        } else {
            console.error('✗ Sticky title element not found!');
        }

        // Update pack information from title (use raw title for pack extraction)
        updateStickyPackInfo(titleElement.textContent.trim());
    } else {
        console.error('✗ Title element not found in product container!');
    }

    // Update price
    if (priceElement) {
        const stickyPrice = stickyCart.querySelector('[data-sticky-price]');
        if (stickyPrice) {
            // Get the most current price from the live DOM, not just the container
            const livePriceElement = document.querySelector('.price, [data-product-price], .product-price, [class*="price"]');
            const priceToUse = livePriceElement || priceElement;
            stickyPrice.innerHTML = priceToUse.innerHTML;
        } else {
            console.error('✗ Sticky price element not found!');
        }

        // Update add to cart button with new price
        updateStickyAddToCartButton(priceElement.textContent.trim());

        // Update per unit price if title is available
        if (titleElement) {
            updateStickyPerUnitPrice(titleElement.textContent.trim(), priceElement.textContent.trim());
        }
    } else {
        console.error('✗ Price element not found in product container!');
    }

    // Update background color of sticky cart
    if (colorElement) {
        const pdpColor = colorElement.textContent.trim();
        updateStickyCartColor(pdpColor);
        console.log('✓ Updated sticky background color:', pdpColor);
    } else {
        console.warn('⚠ Color element not found in product container');
    }

    // Force re-sync with main form after product update
    setTimeout(() => {
        if (window.stickyAddToCart && window.stickyAddToCart.syncWithMainForm) {
            const mainForm = document.querySelector('form[data-product-form]');
            if (mainForm) {
                window.stickyAddToCart.syncWithMainForm(mainForm);
            }
        }
    }, 200);
}

function updateStickyPackInfo(title) {
    const stickyCart = document.getElementById('sticky-add-to-cart');
    if (!stickyCart || !title) return;

    const packMatch = title.split(' - ').pop().match(/(\d+)\s*pack/i);
    const packSize = packMatch ? packMatch[1] : '1';
    
    const stickyPack = stickyCart.querySelector('[data-sticky-pack]');
    if (stickyPack) {
        stickyPack.textContent = `${packSize} Pack`;
        console.log('✓ Updated pack info:', `${packSize} Pack`);
    } else {
        console.error('✗ Sticky pack element not found!');
    }
}

function updateStickyPerUnitPrice(title, price) {
    const stickyCart = document.getElementById('sticky-add-to-cart');
    if (!stickyCart || !title || !price) return;

    const packMatch = title.split(' - ').pop().match(/(\d+)\s*pack/i);
    const packSize = packMatch ? parseInt(packMatch[1]) : 1;
    
    const stickyPerUnit = stickyCart.querySelector('[data-sticky-per-unit]');
    if (stickyPerUnit) {
        if (packSize > 1) {
            // Extract numeric price value
            const priceMatch = price.replace(/[£$€,]/g, '').match(/[\d.]+/);
            if (priceMatch) {
                const numericPrice = parseFloat(priceMatch[0]);
                const perUnitPrice = (numericPrice / packSize).toFixed(2);
                stickyPerUnit.textContent = `£${perUnitPrice} per can`;
                console.log('✓ Updated per unit price:', `£${perUnitPrice} per can`);
            }
        } else {
            // Clear per unit price for single pack
            stickyPerUnit.textContent = '';
            console.log('✓ Cleared per unit price (single pack)');
        }
    } else {
        console.error('✗ Sticky per unit element not found!');
    }
}

function updateStickyAddToCartButton(price) {
    const stickyCart = document.getElementById('sticky-add-to-cart');
    if (!stickyCart || !price) return;

    const stickyBtnText = stickyCart.querySelector('[data-sticky-button-text]');
    if (stickyBtnText) {
        const baseText = 'add to cart';
        stickyBtnText.textContent = `${baseText} - ${price}`;
        console.log('✓ Updated add to cart button:', `${baseText} - ${price}`);
    } else {
        console.error('✗ Sticky button text element not found!');
    }
}

function updateCollapsibleTabs(newProductContainer) {
    // Find all collapsible tab items on current page
    const currentCollapsibleTabs = document.querySelectorAll('[data-collapsible-tab-heading]');

    console.log(`Found ${currentCollapsibleTabs.length} collapsible tabs to update`);

    currentCollapsibleTabs.forEach(currentTab => {
        const heading = currentTab.getAttribute('data-collapsible-tab-heading');

        // Find corresponding tab in the new product data
        const newTab = newProductContainer.querySelector(`[data-collapsible-tab-heading="${heading}"]`);

        if (newTab) {
            // Update the content
            const currentContent = currentTab.querySelector('.rte');
            const newContent = newTab.querySelector('.rte');

            if (currentContent && newContent) {
                console.log(`Updating content for tab: ${heading}`);
                currentContent.innerHTML = newContent.innerHTML;
            }

            // Update the heading text if needed
            const currentHeading = currentTab.querySelector('.collapsible-tab-item__heading');
            const newHeading = newTab.querySelector('.collapsible-tab-item__heading');

            if (currentHeading && newHeading) {
                // Get the text content without icon
                const iconSpan = currentHeading.querySelector('span');
                const iconHTML = iconSpan ? iconSpan.outerHTML : '';
                const newHeadingText = newHeading.textContent.trim();

                currentHeading.innerHTML = iconHTML + newHeadingText;
            }
        } else {
            console.log(`No matching tab found for: ${heading}`);
        }
    });
}

function activateFirstSlide() {
    // Check if Alpine is available
    if (typeof Alpine === 'undefined') {
        return;
    }

    const firstThumbnail = document.querySelector('[data-first-thumbnail]');
    const productRoot = document.querySelector('[data-product-root]');
    
    if (firstThumbnail && productRoot) {
        const firstMediaId = firstThumbnail.getAttribute('data-media-id');
        
        if (firstMediaId) {
            // Find Alpine component and set currentMediaId directly
            const alpineComponent = Alpine.$data(productRoot);
            
            if (alpineComponent && alpineComponent.currentMediaId !== undefined) {
                alpineComponent.currentMediaId = parseInt(firstMediaId);
                alpineComponent.index = 0;
            }
        }
    }
}

function reinitializeSlideshows(productContainer) {
    // Destroy existing slideshows in the product container
    if (window.destroySlideshowsIn) {
        window.destroySlideshowsIn(productContainer);
    }

    // Reinitialize slideshows in the product container immediately
    if (window.discoverNewSlideshows) {
        window.discoverNewSlideshows(productContainer);
    }

    // Initialize progress bar for mobile slides
    if (window.innerWidth <= 990) {
        const slides = productContainer.querySelectorAll('.splide--product');
        slides.forEach(slide => {
            if (window.slideshows && window.slideshows[slide.id]) {
                // Initialize scrollbar immediately
                const scrollBar = slide.querySelector('.my-slider-progress-bar');
                if (scrollBar) {
                    const splideInstance = window.slideshows[slide.id];
                    const end = splideInstance.Components.Controller.getEnd() + 1;
                    const rate = Math.min((splideInstance.index + 1) / end, 1);
                    scrollBar.style.width = String(100 * rate) + '%';

                    // Ensure move event listener is set up
                    splideInstance.on('move', () => {
                        const newEnd = splideInstance.Components.Controller.getEnd() + 1;
                        const newRate = Math.min((splideInstance.index + 1) / newEnd, 1);
                        scrollBar.style.width = String(100 * newRate) + '%';
                    });
                }
            }
        });
    }

    // Activate first slide using requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
        activateFirstSlide();
    });
}

async function fetchProduct(handle){
    try {
        const productContainer = document.querySelector("[data-product-main-container]");
        const sectionId = productContainer?.getAttribute("data-section");
        
        const dataIsland = document.querySelector('[data-product-root]');
        const localizationCountry = dataIsland?.getAttribute('data-localization-country');

        // First, fetch the specific section for main product content
        // Localization is automatically handled by Shopify through cookies/session
        const response = await fetch(`/products/${handle}?section_id=${sectionId}`);
        const data = await response.text();
        const container = document.createElement("div");
        container.innerHTML = data;
        const productContainerFromResponse = container.querySelector("[data-product-main-container]");

        if (productContainer && productContainerFromResponse) {
            productContainer.innerHTML = productContainerFromResponse.innerHTML;

            updateIconColors(productContainerFromResponse);

            // Update sticky cart with new product information
            updateStickyCart(productContainerFromResponse, handle);

            // Reinitialize slideshows after content update
            reinitializeSlideshows(productContainer);
        }

        // Then fetch the full product page for collapsible tabs data and update them
        const fullPageResponse = await fetch(`/products/${handle}`);
        const fullPageData = await fullPageResponse.text();
        const fullPageContainer = document.createElement("div");
        fullPageContainer.innerHTML = fullPageData;

        const newDataIsland = fullPageContainer.querySelector('[data-product-root]');
        if (dataIsland && newDataIsland) {
            const newLocalizationCountry = newDataIsland.getAttribute('data-localization-country');
            const newUseMarketsGallery = newDataIsland.getAttribute('data-use-markets-gallery');
            
            dataIsland.setAttribute('data-localization-country', newLocalizationCountry || localizationCountry);
            dataIsland.setAttribute('data-use-markets-gallery', newUseMarketsGallery || 'false');
        }

        // Update image-with-highlights sections with data from full product page
        if (document.querySelector('[data-image-highlights-section="true"]')) {
            updateImageWithHighlights(fullPageContainer);
        }

        // Update collapsible tabs with data from full product page (after main content is replaced)
        // Small delay to ensure DOM is fully updated
        setTimeout(() => {
            updateCollapsibleTabs(fullPageContainer);
        }, 50);
    } catch (error) {
        console.error("Failed to load product:", error);
    }
}

window.addEventListener("popstate", () => {
    const pathParts = window.location.pathname.split("/");
    const handle = pathParts[pathParts.length - 1] || pathParts[pathParts.length - 2];

    if (document.querySelector("sc-stitching-items")){
        document.querySelector("sc-stitching-items").fetchSelectedProduct(handle).then()
    }else{
        fetchProduct(handle).then()
    }
});

class productStitchingItems extends HTMLElement{
    constructor() {
        super();
        this.productMainContainer = document.querySelector("[data-product-main-container]")
        this.sectionId = this.productMainContainer?.getAttribute("data-section")
        this.querySelectorAll("sc-stitching-items")
    }
    async fetchSelectedProduct(handle){
        try {
            const dataIsland = document.querySelector('[data-product-root]');
            const localizationCountry = dataIsland?.getAttribute('data-localization-country');
            
            // First, fetch the specific section for main product content
            const response = await fetch(`/products/${handle}?section_id=${this.sectionId}`);
            const data = await response.text();
            const container = document.createElement("div");
            container.innerHTML = data;

            const productContainer = document.querySelector("[data-product-main-container]");
            const productContainerFromResponse = container.querySelector("[data-product-main-container]");

            if (productContainer && productContainerFromResponse) {
                productContainer.innerHTML = productContainerFromResponse.innerHTML;

                updateIconColors(productContainerFromResponse);

                // Update sticky cart with new product information
                updateStickyCart(productContainerFromResponse, handle);

                // Add a delayed update to catch any Seal Subscriptions changes
                setTimeout(() => {
                    document.dispatchEvent(new CustomEvent('stitching:productUpdated', {
                        detail: { handle: handle }
                    }));
                }, 1000);

                // Reinitialize slideshows after content update
                reinitializeSlideshows(productContainer);

                // Monitor for Seal Subscriptions price updates
                monitorSealSubscriptionUpdates(productContainer, handle);

                requestAnimationFrame(() => {
                    initLinkedProductsTabs(document);
                });
            }

            // Then fetch the full product page for collapsible tabs data and update them
            const fullPageResponse = await fetch(`/products/${handle}`);
            const fullPageData = await fullPageResponse.text();
            const fullPageContainer = document.createElement("div");
            fullPageContainer.innerHTML = fullPageData;

            const newDataIsland = fullPageContainer.querySelector('[data-product-root]');
            if (dataIsland && newDataIsland) {
                const newLocalizationCountry = newDataIsland.getAttribute('data-localization-country');
                const newUseMarketsGallery = newDataIsland.getAttribute('data-use-markets-gallery');
                
                dataIsland.setAttribute('data-localization-country', newLocalizationCountry || localizationCountry);
                dataIsland.setAttribute('data-use-markets-gallery', newUseMarketsGallery || 'false');
            }

            // Update image-with-highlights sections with data from full product page
            if (document.querySelector('[data-image-highlights-section="true"]')) {
                updateImageWithHighlights(fullPageContainer);
            }

            // Update collapsible tabs with data from full product page (after main content is replaced)
            // Small delay to ensure DOM is fully updated
            setTimeout(() => {
                updateCollapsibleTabs(fullPageContainer);
            }, 50);
        } catch (error) {
            console.error("Failed to load product:", error);
        }
    }
}

// Monitor for Seal Subscriptions updates after product switch
function monitorSealSubscriptionUpdates(productContainer, productHandle) {
    // Listen for Seal Subscriptions events (the sticky cart will handle these directly)
    // We just need to ensure the events are set up for this specific product switch

    // The sticky cart JavaScript now listens directly to:
    // - sealsubs:price_update
    // - sealsubs:selling_plan_changed

    console.log('Seal Subscriptions monitoring active for product:', productHandle);
}

window.customElements.define('sc-stitching-items', productStitchingItems);

class productStitchingItem extends HTMLElement{
    constructor() {
        super();
        this.addEventListener("click", (event)=>{
            if (event) event.preventDefault();
            const productHandle = this.getAttribute("data-product-handle");
            if (document.querySelector("sc-stitching-items")){
                document.querySelector("sc-stitching-items").fetchSelectedProduct(productHandle).then()
            }

            history.pushState({}, "", `/products/${productHandle}`)
        })
    }
}

window.customElements.define('sc-stitching-item', productStitchingItem);

function initLinkedProductsTabs(root = document) {
    const containers = root.querySelectorAll('[data-linked-products-tabs]');
    containers.forEach((container) => {
        const tabs = container.querySelectorAll('.tabs [data-control]');
        const panels = container.querySelectorAll('.product-form__linked-products');

        const stitchingRoot = container.closest('sc-stitching-items');
        const defaultTab = stitchingRoot?.getAttribute('data-default-tab') || 'flavours';
        const packsCount = stitchingRoot?.getAttribute('data-debug-packs-count');
        const flavoursCount = stitchingRoot?.getAttribute('data-debug-flavours-count');

        try {
            const debugItems = container.querySelectorAll('sc-stitching-item[data-debug-handle]');
            if (debugItems.length > 0) {
                console.groupCollapsed('[stitching debug] pack detection');
                console.log({ packsCount, flavoursCount, defaultTab, hasTabs: tabs.length > 0, hasPanels: panels.length > 0 });
                debugItems.forEach((item) => {
                    const handle = item.getAttribute('data-debug-handle') || '';
                    const title = item.getAttribute('data-debug-title') || '';
                    const isPackFromLiquid = item.getAttribute('data-debug-is-pack');
                    const handleContainsPack = handle.includes('pack');
                    const titleContainsPack = title.includes('pack');
                    console.log({
                        handle,
                        title,
                        handleContainsPack,
                        titleContainsPack,
                        isPackFromLiquid,
                    });
                });
                console.groupEnd();
            }
        } catch (e) {
            // no-op
        }

        if (tabs.length === 0 || panels.length === 0) return;

        function activate(tabId) {
            tabs.forEach((t) => {
                const isActive = t.getAttribute('data-control') === tabId;
                t.classList.toggle('active', isActive);
            });

            panels.forEach((p) => {
                p.classList.toggle('show', p.id === tabId);
            });

        }

        const defaultTabButton = container.querySelector(`.tabs [data-control="${defaultTab}"]`);
        const fallbackTab = tabs.length > 0 ? tabs[0].getAttribute('data-control') : null;
        const initialTab = defaultTabButton && !defaultTabButton.disabled ? defaultTab : fallbackTab;
        if (!initialTab) return;
        activate(initialTab);

        tabs.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                if (e) e.preventDefault();
                const id = tab.getAttribute('data-control');
                if (!id) return;
                activate(id);
            });
        });
    });
}

// Initialize progress bar on page load for mobile devices
document.addEventListener('DOMContentLoaded', () => {
    initLinkedProductsTabs(document);
    if (window.innerWidth <= 990) {
        // Small delay to ensure slideshows are initialized
        setTimeout(() => {
            const productSliders = document.querySelectorAll('.splide--product');
            productSliders.forEach(slide => {
                if (window.slideshows && window.slideshows[slide.id]) {
                    const scrollBar = slide.querySelector('.my-slider-progress-bar');
                    if (scrollBar) {
                        const splideInstance = window.slideshows[slide.id];
                        const end = splideInstance.Components.Controller.getEnd() + 1;
                        const rate = Math.min((splideInstance.index + 1) / end, 1);
                        scrollBar.style.width = String(100 * rate) + '%';

                        // Add move event listener for progress bar updates
                        splideInstance.on('move', () => {
                            const newEnd = splideInstance.Components.Controller.getEnd() + 1;
                            const newRate = Math.min((splideInstance.index + 1) / newEnd, 1);
                            scrollBar.style.width = String(100 * newRate) + '%';
                        });
                    }
                }
            });
        }, 200);
    }
});
